import type { FaireProductEntity } from "../../entity_types/product";

export const p_vvr7ut27dc: FaireProductEntity = {
  token: "p_vvr7ut27dc",
  type: "product",
  name: "Mancala Mangowood Game Set",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/712f978299c96d0a2f8cfae2f775fa8e1d3004dd29460a9de09db7e7ffd501a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05fc5efb93a81cbff55d3f4b2b597485ddc7880ecc0cc0c2ff4528e97de0d982.jpeg",
    "https://cdn.faire.com/fastly/19dcaea16e29c8fb4f46e3eabf2f543e1384905d228592475dc3ef751655388f.jpeg",
    "https://cdn.faire.com/fastly/e5895ffa1ccf717066aca3da5b73abd3d63f55b1752c67d94e17dd4b4d1cb846.jpeg",
    "https://cdn.faire.com/fastly/09fa5a90711984a321144990648f6ebfa524d7148a34d3673e949f01045fbf72.jpeg",
    "https://cdn.faire.com/fastly/59ef327880fa25e81fe9e9bddd8f78eda7a036d5f538053c66cb4acbee1fed0a.jpeg",
    "https://cdn.faire.com/fastly/1b51bd907d43d684f1fa37fa16a730534bc8bcf6e0be601a6788cae2c7baf829.jpeg",
    "https://cdn.faire.com/fastly/a294073fa41005c193a3d190dfb71f94d3461d6751001ee101e12c50f9790338.jpeg",
    "https://cdn.faire.com/fastly/eba24c07326a5522fca8e6980d3befb40e07a53ab0570d2d79b3aa6cf4b233b4.jpeg",
  ],
  priceDollars: 17.5,
  description:
    "Mancala is one of the oldest known games to be played around the world, with roots that trace back thousands of years, making it a rich part of global cultural heritage. This game of strategy involves a board lined with pits or holes, and a collection of seeds, stones, or beans that are distributed in a loop pattern across these pits. The simplicity of the game’s tools paired with its deep strategic elements has allowed it to stand the test of time and spread across continents. The Verve Culture Mancala Set features handmade wooden pieces and a mangowood box.\n\nThis enduring game not only entertains but also connects players to the many generations and cultures that have contributed to its continuous evolution. Verve Culture's Mancala set invites you to be part of this ancient tradition, providing a tactile connection to history through the simple act of playing.\n\nFolded Dimensions - 10.25'' x 5'' x 2''\nUnfolded Dimensions - 19.5'' x 5'' x 1''",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:21.518Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
